import { Component } from "react";
// import { useSelector, useDispatch } from "react-redux";
import "./home.css";

export function HomePage(props) {
  const toggleLogin = () => {
    console.log(props.data);
    props.data.loggedIn(true);
  };

  return (
    <>
      <div className="login-page">
        <div className="intro-info">
          <h1>
            Welcome to <b>Docs-io</b> App
          </h1>
          <h2>
            {" "}
            A Personalised Online Documentation with <b>Concepts</b> friendly
            Hierarchy Framework.{" "}
          </h2>
          <button
            type="button"
            class="btn btn-secondary"
            onClick={toggleLogin.bind()}
          >
            Guest Login
          </button>
        </div>
        {/* <h2> Use <b>Google Login</b> For Personalised Experience. </h2> */}
      </div>
    </>
  );
}
